import { LogicNameFilter } from "../../../../../utils/constants";
import { filterName } from "../utils";

export const applyDatastoreFilters = (
  entities,
  appliedFilters,
  filterAndOrLogics
) => {
  let filteredEntities = [...entities];

  // Datastore Type
  if (
    filterName.DATASTORE_TYPE in appliedFilters &&
    Object.keys(appliedFilters[filterName.DATASTORE_TYPE]).length > 0
  ) {
    const checkedTypes = Object.keys(
      appliedFilters[filterName.DATASTORE_TYPE]
    ).filter((type) => appliedFilters[filterName.DATASTORE_TYPE][type]);
    if (checkedTypes.length > 0) {
      filteredEntities = filteredEntities.filter((entity) =>
        checkedTypes.includes(entity?.resource_type)
      );
    }
  }

  // Backup
  if (
    filterName.BACKUP in appliedFilters &&
    Object.keys(appliedFilters[filterName.BACKUP]).length > 0
  ) {
    const checkedBackups = Object.keys(
      appliedFilters[filterName.BACKUP]
    ).filter((key) => appliedFilters[filterName.BACKUP][key]);
    if (checkedBackups.length > 0) {
      filteredEntities = filteredEntities.filter((entity) => {
        const status = entity?.mongo_atlas_data?.is_backup_enabled
          ? "Enabled"
          : "Disabled";
        return checkedBackups.includes(status);
      });
    }
  }

  // Public Access
  if (
    filterName.PUBLIC_ACCESS in appliedFilters &&
    filterName.PUBLIC_ACCESS in filterAndOrLogics &&
    Object.keys(appliedFilters[filterName.PUBLIC_ACCESS]).length > 0
  ) {
    const checkedPublicAccess = Object.keys(
      appliedFilters[filterName.PUBLIC_ACCESS]
    ).filter((key) => appliedFilters[filterName.PUBLIC_ACCESS][key]);

    if (checkedPublicAccess.length > 0) {
      filteredEntities = filteredEntities.filter((entity) => {
        if (
          filterAndOrLogics[filterName.PUBLIC_ACCESS] ===
          LogicNameFilter.LOGIC_OR
        ) {
          return checkedPublicAccess.some((publicAccess) =>
            entity?.public_permissions?.includes(publicAccess)
          );
        } else if (
          filterAndOrLogics[filterName.PUBLIC_ACCESS] ===
          LogicNameFilter.LOGIC_AND
        ) {
          return checkedPublicAccess.every((publicAccess) =>
            entity?.public_permissions?.includes(publicAccess)
          );
        }
      });
    }
  }

  entities.length = 0;
  for (let i = 0; i < filteredEntities.length; i++) {
    entities[i] = filteredEntities[i];
  }
};
